import { Checkbox, Modal, Spin, Tooltip } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { TEntityLink } from "components/feature-entity-linking-page/models";
import { MUTATION_UPDATE_MATERIAL_TRACKING } from "components/feature-entity-linking-page/queries/mutation";
import { ErrorMessages } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { useContext, useState } from "react";

export default function MaterialTrackingCheckbox({
  selectedEntityInfo,
  refetchEntityInfo,
  disable
}: {
  selectedEntityInfo: TEntityLink;
  refetchEntityInfo: () => Promise<void>;
  disable: boolean;
}) {
  const { gqlClientForProject, isProjectArchived } = useContext(ProjectContext);
  const tooltipTitle =
    !isProjectArchived && disable ? ErrorMessages.EditingLinkingMessage : null;
  const [loading, setLoading] = useState(false);

  const [updateMaterialTrackingMutation] = useCIQMutation(
    MUTATION_UPDATE_MATERIAL_TRACKING,
    {
      client: gqlClientForProject
    }
  );

  const materialTrackingOnOff = async (checked: boolean) => {
    setLoading(true); // Start loading
    // Simulate an API call or async operation
    await updateMaterialTrackingMutation({
      variables: {
        featureInstanceIds: selectedEntityInfo.ids,
        material_tracking: checked
      }
    });
    await refetchEntityInfo();
    setLoading(false); // Stop loading
  };

  const handleChange = async (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      materialTrackingOnOff(true);
    } else {
      Modal.confirm({
        title: "Disable Material Tracking?",
        content:
          "All the linked Materials from your selected Submittal will be removed.",
        className: "skip-listing-window custom-rounded-modal",
        onOk() {
          materialTrackingOnOff(false);
        },
        okText: "Yes, disable"
      });
    }
  };

  return selectedEntityInfo?.feature_submittals?.length ? (
    <Tooltip
      title={tooltipTitle}
      data-testid="materialtrackingchechbox-tooltip"
    >
      <Spin spinning={loading} data-testid="materialtrackingchechbox-spin">
        <Checkbox
          checked={selectedEntityInfo.feature_submittals[0].material_tracking}
          onChange={handleChange}
          disabled={disable || !!isProjectArchived}
          data-testid="materialtrackingchechbox-checkbox"
        >
          Track Material
        </Checkbox>
      </Spin>
    </Tooltip>
  ) : null;
}
